"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BaseAvroRecord {
}
BaseAvroRecord.subject = "";
BaseAvroRecord.schema = {};
exports.BaseAvroRecord = BaseAvroRecord;
//# sourceMappingURL=BaseAvroRecord.js.map